import React from "react";
import { Box, keyframes } from "@chakra-ui/react";
import logo from "../../../assets/logo_dark_small.png";

/**
 * Spinning + pulsing animation for the thinking logo.
 * One full rotation per 1.5s cycle: shrinks to half size at 1/3 spin, back to full at 2/3, full size at end.
 * Each keyframe % is a point in time: 0% = animation start, 100% = end (then it loops).
 * Between keyframes the browser smoothly interpolates the rotation and scale.
 */
export const agentThinkingAnimation = keyframes`
  0%   { transform: rotate(0deg)   scale(1);   } /* start — full size, no rotation */
  33%  { transform: rotate(120deg) scale(0.5); } /* shrink — 1/3 spin done */
  66%  { transform: rotate(240deg) scale(1);   } /* expand — 2/3 spin done */
  100% { transform: rotate(360deg) scale(1);   } /* 1 full spin complete — loops back to 0% */
`;

export interface AgentThinkingLogoProps {
  boxSize?: string | number;
}

const AgentThinkingLogo: React.FC<AgentThinkingLogoProps> = ({ boxSize = "14px" }) => (
  <Box
    as="img"
    src={logo}
    alt=""
    boxSize={boxSize}
    flexShrink={0}
    transformOrigin="center center"
    animation={`${agentThinkingAnimation} 1.5s ease-in-out infinite`}
  />
);

export default AgentThinkingLogo;
